import React from "react"
import _ from "lodash"
import PropTypes from "prop-types"
import CurrencyCodes from "currency-codes"
import { FormControl, MenuItem, Select } from "@material-ui/core"
import { formsAction } from "../../i18n/lstrings"
import useSmartFormat from "../../i18n/useSmartFormat"

export default function CurrencySelect(props) {
  const { onChange, className, defaultValue } = props
  const format = useSmartFormat()
  const defaultSelectString = format(formsAction.defaultFormSelectLabel)
  const codes = CurrencyCodes.codes()

  return (
    <FormControl variant="outlined" size="small" className={className}>
      <Select
        defaultValue={defaultValue}
        value={defaultValue}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="" disabled>
          {defaultSelectString}
        </MenuItem>
        {codes.map((currencyCode) => {
          return (
            <MenuItem key={currencyCode} value={currencyCode}>
              {currencyCode}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

CurrencySelect.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.object.isRequired,
  defaultValue: PropTypes.string
}

CurrencySelect.defaultProps = {
  onChange: _.noop,
  defaultValue: "USD"
}
